import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Compagnia } from 'src/app/models/compagnia';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'compagnie-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class CompagnieFormComponent extends BaseEditForm implements OnInit {

  compagnia: Compagnia;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<CompagnieFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Compagnia,) {
    super();
    this.compagnia = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.compagnia?.nome, Validators.required],
      via: [this.compagnia?.via],
      civico: [this.compagnia?.civico],
      comune: [this.compagnia?.comune],
      gruppo: [this.compagnia?.gruppo],
      tel: [this.compagnia?.tel],
      fax: [this.compagnia?.fax],
      cell: [this.compagnia?.cell],
      email: [this.compagnia?.email],
      concordato_visibile: [this.compagnia?.concordato_visibile ?? false],
    });
  }

}

